const randomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const randomString = (size) => {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomString2 = "";
  for (let i = 0; i < size; i++) {
    randomString2 += chars[randomInt(0, chars.length - 1)];
  }
  return randomString2;
};
const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export { randomInt, randomIntFromInterval, randomString };
//# sourceMappingURL=index.js.map
